<template>
  <main :class="mainContainerClass" class="px-5">
    <h4 v-if="isFromInvoiceAdmin">Invoices</h4>
    <div class="d-inline" v-if="currentUser.role_id == 1">
      <Tabs :tabs="tabs" @change="changeTab($event)" :tabSelected="tabSelected" />
    </div>
    <LoadingSpinner v-if="loading" />
    <div class="pt-2" v-if="!loading">
      <!-- filtros de busqueda -->
      <div class="card p-2">
        <div class="row">
          <div class="col-12 col-lg-6 p-1">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">{{ $t("lang.label.payment_date") }}:</span>
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">From</span>
              </div>
              <date-picker id="startDatePicker" class="form-control" v-model="filterSearch.paymentRange.startDate"
                :config="datePickerConfigPayment" placeholder="Start Date"></date-picker>
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">to</span>
              </div>
              <date-picker id="endDatePicker" class="form-control" v-model="filterSearch.paymentRange.endDate"
                :config="datePickerConfigEndDatePayment" :disabled="isEndDateDisabled"
                placeholder="End Date"></date-picker>
            </div>
          </div>
          <div class="col-12 col-lg-6 p-1">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">{{ $t("lang.label.billing_date") }}:
                </span>
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">From</span>
              </div>
              <date-picker id="startDatePicker2" class="form-control" v-model="filterSearch.billingRange.startDate"
                :config="datePickerConfigBilling" placeholder="Start Date"></date-picker>
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">to</span>
              </div>
              <date-picker id="endDatePicker2" class="form-control" v-model="filterSearch.billingRange.endDate"
                :config="datePickerConfigEndDateBilling" placeholder="End Date"></date-picker>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 col-lg-6 p-1">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text" id="invoices-filter-label">{{ $t("lang.label.invoices") }}</span>
              </div>
              <input type="number" class="form-control" v-model.number="filterSearch.payment_id" min="0"
                aria-labelledby="invoices-filter-label" />
            </div>
          </div>
          <div class="col-12 col-lg-6 p-1">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text" id="product-type-filter-label">{{ $t("lang.label.product_type") }}</span>
              </div>
              <select class="form-control" v-model="filterSearch.payment_type_id"
                aria-labelledby="product-type-filter-label">
                <option v-for="product in productTypes" :key="product.id" :value="product.id">
                  {{ product.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row align-items-end mt-2">
          <div class="col-12 col-md-6 col-lg-4 p-1 invoices-filter-col position-relative"
            v-if="currentUser.role_id != 4">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text" id="client-filter-label">{{ $t("lang.label.client") }}</span>
              </div>
              <treeselect :disabled="loadingClients" v-model="filterSearch.client_id" :options="clientsForTreeselect"
                :normalizer="normalizeOptions" :searchable="true" :multiple="false" :clearable="true" :max-height="300"
                v-bind:placeholder="$t('lang.label.search')" @search-change="onClientSearchChange"
                class="form-control inline-table flex-grow-1" aria-labelledby="client-filter-label" />
              <small v-if="loadingClients" style="width:15px;height:15px; position: absolute; bottom: 33px; right: 0px;"
                class="spinner-border loading-spinner"></small>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 p-1 invoices-filter-col" v-if="currentUser.role_id != 4">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text" id="am-filter-label">Account Manager</span>
              </div>
              <IndustrySearch :option_list="userOliverSales" :default_values="userOliverSale" :key="3" :multiple="false"
                :isDisabled="loading" @selected="selectOliverSale" class="form-control inline-table flex-grow-1"
                aria-labelledby="am-filter-label" />
            </div>
          </div>
          <div
            :class="currentUser.role_id == 4 ? 'col-12 text-right' : 'col-12 col-lg-4 p-1 d-flex align-items-center justify-content-lg-end justify-content-start mt-2 mt-lg-0'">
            <button class="btn btn-success" :disabled="loading" @click="loadRangeStats()">
              <i class="icon-calendar-check-o mr-2"></i>
              <small>
                {{ $t("lang.label.letsgetstarted") }}
              </small>
            </button>
          </div>
        </div>
      </div>

      <!-- paginacion y totales -->
      <div class="col-md-12 w-100 my-2 card px-2">
        <div class="row my-2">
          <div class="col-md-12">
            <span class="mr-1">{{ $t("lang.label.results") }}:</span>
            <small v-if="!total" class="ml-1 text-primary mr-4">{{ $t("lang.search.calculating") }}...</small>
            <strong class="mr-5" v-else>{{ total }}</strong>
            <div class="row">
              <div class="col-md-5">
                <span class="mr-1">{{ $t("lang.column.amount") }}:</span>
                <small v-if="totalAmount < 0" class="ml-1 text-primary mr-4">{{ $t("lang.search.calculating")
                }}...</small>
                <strong class="mr-5" v-else>€ {{ totalAmount }}</strong>
                <button class="ml-2 btn btn-sm btn-primary" @click="getToDownload()" :disabled="processingAllItems">
                  <span v-if="!processingAllItems">Download csv</span>
                  <span v-else>Processing...</span>
                </button>
              </div>
              <div class="col-md-7">
                <Pagination :total="total" :totalpages="totalPageInvoices" :model="pagination" :limit="false"
                  :color="'primary'" key="paginationkey" @changePage="getData"></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- invoices table (invoiceFormats en table.vue) -->
      <div class="card mt-3 p-4">
        <div class="table table-responsive thead-dark">
          <Table class="mx-2 w-100" :headers="headers" :cols="cols" :data="invoices" :checkbox="false" :notselect="true"
            :model="model" :fieldsLoading="fieldsLoading" :key="100" @pdfDownload="pdfDownload($event)"
            @changePaymentStatus="changePaymentStatus" @goToClient="goToClient">
          </Table>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { billingsService, adminService, clientsService, usersService } from "@/_services";
import { pdfInvoiceMixin, statusBadgeMixin } from "@/_mixins/";
import Tabs from "@/components/Common/Tabs.vue";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import Treeselect from "@riophae/vue-treeselect";
import IndustrySearch from "../AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
import moment from "moment";

/** Clientes visibles en el filtro de facturas: solo estos `client_status_id`. */
const INVOICES_CLIENT_STATUS_IDS_ALLOWED = [4, 7, 8, 5, 6];

const INVOICES_PINNED_CLIENT_ID = 2389;

export default {
  data() {
    return {
      processingAllItems: false,
      loading: true,
      fieldsLoading: true,
      isFromInvoiceAdmin: false,
      loadingClients: false,
      clientSearchQuery: "",
      clientSearchTimer: null,
      userOliverSales: [{ id: "0", label: "Select option..." }, { id: "all", label: "All" }],
      userOliverSale: ['0'],
      accountManagerId: null,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      invoices: [],
      clients: [],
      datePickerConfigBilling: {
        format: "YYYY-MM",
        viewMode: "months",
        useCurrent: false,
        maxDate: moment().endOf("month"),
      },
      productTypes: [
        { id: 0, name: "All" },
        { id: 1, name: "Leads" },
        { id: 2, name: "License" },
        { id: 4, name: "Contact enrichment" },
      ],
      datePickerConfigEndDateBilling: {
        format: "YYYY-MM",
        viewMode: "months",
        useCurrent: false,
        maxDate: moment().endOf("month"),
      },
      datePickerConfigPayment: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },

      datePickerConfigEndDatePayment: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      filterSearch: {
        payment_type_id: 0,
        payment_id: "",
        paymentRange: {
          startDate: null,
          endDate: null,
        },
        billingRange: {
          startDate: moment().subtract(6, "months").format("YYYY-MM"),
          endDate: moment().format("YYYY-MM"),
        },
        client_id: null,
      },
      unparsedResults: null,
      tabSelected: 1,
      total: 10,
      totalAmount: 0,
      totalInvoices: 0,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      filters: [],
      lastFilters: [],
      invoicesAllItems: [],
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.label.all"),
          paymentStatusId: 0,
        },
        2: {
          id: 2,
          name: this.$t("lang.payment.Paid"),
          paymentStatusId: 2,
          icon: "icon-dollar",
        },
        3: {
          id: 3,
          name: this.$t("lang.payment.Declined"),
          paymentStatusId: 3,
          icon: "icon-frown-o",
        },
        4: {
          id: 4,
          name: this.$t("lang.payment.Exonerated"),
          paymentStatusId: 4,
          icon: "icon-star-o",
        },
        5: {
          id: 5,
          name: this.$t("lang.payment.Canceled"),
          paymentStatusId: 6,
          icon: "icon-remove",
        },
        6: {
          id: 6,
          name: this.$t("lang.payment.Pending"),
          paymentStatusId: 1,
          icon: "icon-watch_later",
        },
        7: {
          id: 7,
          name: "SEPA",
          paymentStatusId: 9,
          icon: "icon-bank",
        },
        8: {
          id: 8,
          name: this.$t("lang.label.bank_transfer"),
          paymentStatusId: 11,
          icon: "icon-money",
        },
      },
      cols: [
        [
          {
            value1: "id",
            value2: "date",
            value3: "label_payment_type",
            value4: "label_payment_class",
            format: 1,
            type: "invoiceFormats",
          },
        ],
        [
          {
            value1: "client_name",
            value2: "client_id",
            value3: "legal_representative",
            format: 2,
            emit: "goToClient",
            type: "invoiceFormats",
          },
        ],
        [
          {
            value: "client_status_badge",
            type: "html",
          },
        ],
        [
          {
            value: "account_manager",
          }
        ],
        [
          {
            value: "payment_type",
          },
        ],
        [
          {
            value: "payment_method_type",
            type: "itemBadge",
            colors: [
              {
                id: "sepa",
                label: "SEPA",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "credit_card",
                label: "Credit Card",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "bank_transfer",
                label: "Bank Transfer",
                bgColor: "yellow",
                textColor: "#000000",
              },
            ],
          },
        ],
        [
          {
            value2: "card_number",
            value3: "sepa_bank",
            value4: "sepa_id",
            value5: "sepa_creation_date",
            value6: "sepa_direct_credit",
            value7: "payment_method_primary",
            value8: "bank_transfer_start_date",
            value9: "bank_transfer_contractual_days",
            value10: "payment_status_id",
            value11: "payment_method_type",
            btnId: "id",
            emit: "pdfDownload",
            format: 3,
            type: "invoiceFormats",
          },
        ],
        [
          {
            value: "ingenico_pay_id",
          },
        ],
        [
          {
            value: "transaction_id",
          },
        ],
        [
          {
            value: "payment_date",
          },
        ],
        [
          {
            value: "montat_per_invoice",
            format: "money",
            simbol: "€"
          },
        ],
        [
          {
            value: "vats_per_invoice",
            format: "money",
            simbol: "€"
          },
        ],
        [
          {
            value: "amount_with_vat",
            format: "money",
            simbol: "€"
          },
        ],
        [
          {
            btnId: "id",
            value1: "payment_status_id",
            value2: "has_payment_method",
            value8: "bank_transfer_start_date",
            value9: "bank_transfer_contractual_days",
            value11: "payment_method_type",
            emit: "changePaymentStatus",
            format: 4,
            type: "invoiceFormats",
          },
        ],
      ],
      headers: [
        {
          label: this.$t("lang.column.invoicenumber"),
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.company"),
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Client status",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Account Manager",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Payment Type",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: this.$t("lang.column.paymentmethod"),
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Payment method details",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Ref Id",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 5,
        },
        {
          label: "Tx Id (Viva)",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 6,
        },
        {
          label: this.$t("lang.label.payment_date"),
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 7,
        },
        {
          label: this.$t("lang.column.amount") + " H.T",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 8,
        },
        {
          label: "VAT (20%)",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 9,
        },
        {
          label: this.$t("lang.column.total") + " TTC",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 10,
        },
        {
          label: "Actions",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["superAdmin"],
          id: 11,
        }
      ],
    };
  },
  components: {
    LoadingSpinner,
    Tabs,
    Pagination,
    Treeselect,
    Table,
    IndustrySearch,
  },
  mixins: [pdfInvoiceMixin, statusBadgeMixin],
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    mainContainerClass() {
      if (this.isFromInvoiceAdmin) {
        return {
          'main p-3': true,
          'expand-main': this.isMenuCollapse
        };
      }
      return 'contenedor';
    },
    totalPageInvoices() {
      return this.invoices.length;
    },
    isEndDateDisabled() {
      return !this.filterSearch.paymentRange.startDate;
    },
    clientsForTreeselect() {
      var q = (this.clientSearchQuery || "").trim().toLowerCase();

      // Si no escribió nada, muestra pocos (evita render masivo); cliente fijado siempre visible si existe
      if (!q) {
        var limit = 50;
        var first = this.clients.slice(0, limit);
        var pinned = this.clients.find(function (c) {
          return c.id == INVOICES_PINNED_CLIENT_ID;
        });
        if (!pinned || first.some(function (c) { return c.id == pinned.id; })) {
          return first;
        }
        return [pinned].concat(
          first.filter(function (c) { return c.id != pinned.id; }).slice(0, limit - 1)
        );
      }

      // Exige mínimo 2 chars para evitar filtrar en cada tecla
      if (q.length < 2) return [];

      var out = [];
      for (var i = 0; i < this.clients.length; i++) {
        var c = this.clients[i];
        // usamos campo pre-normalizado para filtrar más rápido
        if (c._search && c._search.indexOf(q) !== -1) {
          out.push(c);
          if (out.length >= 200) break; // límite duro
        }
      }
      return out;
    },
  },
  created() {
    if (this.$route.fullPath != "/settings-account") {
      this.isFromInvoiceAdmin = true;
      this.setHeader();
    }
    this.getClients();
    this.getUserOliverSales();
    this.getData();
  },
  watch: {
    unparsedResults(current) { },
    "filterSearch.paymentRange.startDate"(newVal) {
      if (newVal && !this.filterSearch.paymentRange.endDate) {
        this.filterSearch.paymentRange.endDate = newVal;
      }
    },
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild"
    }),
    setHeader() {
      this.setCurrentRoute({ page: "invoices_admin", label: "Invoices" });
      this.setCurrentRouteChild({ child: "" });
    },
    selectOliverSale(selected) {
      if (selected.id != 0) {
        this.accountManagerId = selected.id;
      } else {
        this.userOliverSale = ['0'];
        this.this.accountManagerId = null;
      }
      this.loadInvoices();
    },
    getUserOliverSales() {
      usersService
        .getUserOliverSales(true, 0, true)
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.oliverSalesLoaded = true;
          }
        })
        .catch((err) => console.err(err));
    },
    pdfDownload(id) {
      // const object = this.invoices.find(item => item.id === id);
      // this.downloadPDF(object);
      billingsService.downloadInvoice(id).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename || `invoice-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    },
    changePaymentStatus(paymentId, paymentStatusId) {
      adminService
        .changePaymentStatus(paymentId, paymentStatusId)
        .then((result) => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            showConfirmButton: false,
            timer: 2500,
          });
          this.getData();
        })
        .catch((err) => {
          const is402 = this.paymentChangeIs402(err);
          const is409 = !is402 && this.paymentChangeIs409(err);
          const is400 = !is402 && !is409 && this.paymentChangeIs400(err);

          if (is402) {
            this.$swal({
              type: "error",
              title: "Error",
              text: this.$t("lang.general.error_402"),
              showConfirmButton: false,
              timer: 1500,
            });
          } else if (is409) {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              text: this.paymentChargeBlockMessage(err),
              showConfirmButton: true,
            });
          } else if (is400) {
            this.$swal({
              type: "error",
              title: "Error",
              text: this.$t("lang.general.error_400"),
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: true,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    paymentChangeErrorText(err) {
      if (err == null) return "";
      if (typeof err === "string") return err;
      const parts = [err.message, err.error, err.msg, err.title, err.exception].filter(
        (x) => x !== undefined && x !== null && String(x).trim() !== ""
      );
      return parts.map((x) => String(x)).join(" ");
    },
    paymentChangeIs402(err) {
      const t = this.paymentChangeErrorText(err);
      return (
        Number(err && err.status) === 402 ||
        /OLVSTATE\[402\]/i.test(t) ||
        /Payment Declined/i.test(t)
      );
    },
    paymentChangeIs400(err) {
      const t = this.paymentChangeErrorText(err);
      return (
        Number(err && err.status) === 400 ||
        /Payment method not credit card/i.test(t)
      );
    },
    paymentChangeIs409(err) {
      return (
        Number(err && err.status) === 409 ||
        (err && err.error === "card_not_chargeable")
      );
    },
    paymentChargeBlockMessage(err) {
      if (err && typeof err === "object" && err.message) return err.message;
      const t = this.paymentChangeErrorText(err);
      return t || "Cette facture ne peut pas être prélevée.";
    },
    goToClient(clientId) {
      if (this.currentUser.role_id != 1) return;
      let url = "/clients/" + clientId;
      window.open(url, "_blank");
    },
    onClientSearchChange(query) {
      var self = this;
      if (this.clientSearchTimer) clearTimeout(this.clientSearchTimer);
      this.clientSearchTimer = setTimeout(function () {
        self.clientSearchQuery = query || "";
      }, 200);
    },
    changeTab(id) {
      if (this.tabSelected === id) return;
      this.pagination.cantPerPage = 25;
      this.pagination.currentPage = 1;
      this.filterSearch.payment_type_id = 0;
      this.filterSearch.payment_id = "";
      this.filterSearch.billingRange.startDate = moment()
        .subtract(6, "months")
        .format("YYYY-MM");
      this.filterSearch.billingRange.endDate = moment().format("YYYY-MM");
      this.filterSearch.paymentRange.startDate = null;
      this.filterSearch.paymentRange.endDate = null;
      this.filterSearch.client_id = null;

      if (!this.loading) {
        this.tabSelected = id;
        this.getData();
        this.getTotalInvoices();
      }
    },
    invoicePaymentMethodDetailsForCsv(item) {
      const parts = [
        item.card_number,
        item.sepa_bank,
        item.sepa_id,
        item.sepa_creation_date,
        item.sepa_direct_credit,
      ].filter(
        (x) =>
          x !== undefined &&
          x !== null &&
          String(x).trim() !== ""
      );
      return parts.join(" | ");
    },
    paymentDateForCsv(value) {
      if (!value) return "";
      const s = String(value);
      return s.length >= 10 ? s.substring(0, 10) : s;
    },
    mapInvoiceToCsvRow(item) {
      return {
        "Invoice nb": item.id,
        "Invoice date": this.paymentDateForCsv(item.date),
        "Invoice status": item.payment_status,
        "Client name": item.client_name,
        "Client status": this.getClientStatusLabel(item.client_status),
        "Account Manager": item.account_manager,
        "Payment Type": item.payment_type,
        "Méthode de paiement": item.payment_method_type,
        "Payment method details": this.invoicePaymentMethodDetailsForCsv(item),
        "Ref Id": item.ingenico_pay_id,
        "Tx Id (Viva)": item.transaction_id,
        "Date de paiement": this.paymentDateForCsv(item.payment_date),
        "Montant H.T": item.montat_per_invoice,
        "VAT (20%)": item.vats_per_invoice,
        "Total TTC": item.amount_with_vat,
      };
    },
    descargarCsv() {
      const datosExportar = this.invoices.map((row) =>
        this.mapInvoiceToCsvRow(row)
      );
      this.unparsedResults = this.$papa.unparse(datosExportar, {
        delimiter: ";",
      });
      this.$papa.download(this.unparsedResults, "report-invoices");
    },
    getToDownload() {
      this.processingAllItems = true;
      const paymentStatusId = this.tabs[this.tabSelected].paymentStatusId;
      const filters = { ...this.filterSearch };
      billingsService
        .getInvoices(999999, 1, paymentStatusId, 0, filters)
        .then((result) => {
          const list = result.list || [];
          list.forEach((item) => {
            item.montat_per_invoice = ((item.amount - item.discount_amount - item.discount_previous_payment) * 1).toFixed(2);
            item.vats_per_invoice = ((item.amount_with_vat - item.amount - ("-" + item.discount_amount)) * 1).toFixed(2);
          });
          this.invoicesAllItems = list;
          this.download();
        })
        .finally(() => {
          this.processingAllItems = false;
        });
    },

    download() {
      const datosExportar = this.invoicesAllItems.map((row) =>
        this.mapInvoiceToCsvRow(row)
      );
      this.unparsedResults = this.$papa.unparse(datosExportar, {
        delimiter: ";",
      });
      this.$papa.download(this.unparsedResults, "report-invoices");
    },

    getData() {
      this.getInvoices();
    },
    loadRangeStats() {
      this.pagination.cantPerPage = 25;
      this.pagination.currentPage = 1;
      if (this.filterSearch.payment_id != "") {
        this.tabSelected = 1;
      }
      this.getInvoices();
      this.getTotalInvoices();
    },
    getClientPaymentStatusBadge(paymentStatusId) {
      const statusId = Number(paymentStatusId);
      if ([2, 5].includes(statusId)) {
        return { label: this.$t("lang.payment.Paid"), class: 'badge-success' };
      }
      if ([1, 7, 8, 9, 10, 11].includes(statusId)) {
        return { label: this.$t("lang.payment.in_progress"), class: 'badge-warning' };
      }
      if (statusId === 3) {
        return { label: this.$t("lang.payment.Declined"), class: 'badge-danger' };
      }
      return null;
    },
    getClientStatusLabel(status) {
      return status == 'Pending deleted' ? 'Payment declined' : (status || '');
    },
    getClientStatusPlaceHolder(status) {
      switch (status) {
        case 'Proposal':
          return 'badge badge-info';
        case 'Outdated':
          return 'badge badge-secondary';
        case 'Preparing':
          return 'badge badge-warning';
        case 'Active':
          return 'badge badge-success';
        case 'Standby':
          return 'badge badge-warning';
        case 'Deleted':
          return 'badge badge-danger';
        case 'Recovery':
          return 'badge badge-info';
        case 'Pending deleted':
          return 'badge badge-danger';
        case 'Validation':
          return 'badge badge-warning';
      }
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.label
      };
    },
    getInvoices() {
      if (this.filters != this.lastFilters) {
        this.getTotalInvoices();
      }
      this.loading = true;
      this.totalInvoices = 0;
      this.filters.cantPerPage = this.pagination.cantPerPage;
      this.filters.currentPage = this.pagination.currentPage;
      this.filterSearch.account_manager_id = this.accountManagerId == 'all' ? 0 : this.accountManagerId;

      let paymentStatusId = this.tabs[this.tabSelected].paymentStatusId;
      billingsService
        .getInvoices(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          paymentStatusId,
          this.totalInvoices,
          this.filterSearch
        )
        .then((result) => {
          this.invoices = result.list;

          this.invoices.forEach((item) => {
            item.montat_per_invoice = ((item.amount - item.discount_amount - item.discount_previous_payment) * 1).toFixed(2);
            item.vats_per_invoice = ((item.amount_with_vat - item.amount - ("-" + item.discount_amount)) * 1).toFixed(2);
            if (item.payment_status != 'SEPA Direct Debit') {
              item.label_payment_type = this.$t("lang.payment." + item.payment_status);
            } else {
              item.label_payment_type = 'SEPA';
            }
            item.label_payment_class = 'badge-primary';
            if (this.currentUser.role_id != 1) {
              const clientStatusBadge = this.getClientPaymentStatusBadge(item.payment_status_id);
              if (clientStatusBadge) {
                item.label_payment_type = clientStatusBadge.label;
                item.label_payment_class = clientStatusBadge.class;
              }
            }
            item.client_status_badge = item.client_status
              ? '<span class="' + this.getClientStatusPlaceHolder(item.client_status) + '">' + this.getClientStatusLabel(item.client_status) + '</span>'
              : '';
          });
        })
        .then((result) => {
          this.lastFilters = this.filters;
          this.loading = false;
        });
    },
    async getClients() {
      this.loadingClients = true;
      try {
        var result = await clientsService.getAll();

        // ✅ sin ?. ni ??
        var list = Array.isArray(result)
          ? result
          : (result && result.data ? result.data : []);

        list = list.filter(function (client) {
          var sid = parseInt(client.client_status_id, 10);
          return INVOICES_CLIENT_STATUS_IDS_ALLOWED.indexOf(sid) !== -1;
        });

        this.clients = (Array.isArray(list) ? list : []).map(function (client) {
          var label = client.name || "";
          return {
            id: client.id,
            label: label,
            _search: String(label).toLowerCase(), // ✅ ayuda al filtro
          };
        });

        // Si quedó un valor inválido seleccionado, límpialo
        if (
          this.filterSearch.client_id != null &&
          !this.clients.some((c) => c.id === this.filterSearch.client_id)
        ) {
          this.filterSearch.client_id = null;
        }
      } finally {
        this.loadingClients = false;
      }
    },
    getTotalInvoices() {
      this.totalInvoices = 1;
      this.filters.cantPerPage = this.pagination.cantPerPage;
      this.filters.currentPage = this.pagination.currentPage;
      this.filterSearch.account_manager_id = this.accountManagerId == 'all' ? 0 : this.accountManagerId;

      let paymentStatusId = this.tabs[this.tabSelected].paymentStatusId;
      //endpoint para traer total de facturas
      billingsService
        .getInvoices(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          paymentStatusId,
          this.totalInvoices,
          this.filterSearch
        )
        .then((result) => {
          this.total = result.total;
          this.totalAmount = result.total_amount;
          if (this.totalAmount == null) this.totalAmount = 0;
        });
    },
  },
};
</script>
<style scoped>
/* Treeselect / componentes dentro de input-group: permitir encoger en columnas estrechas */
.invoices-filter-col {
  min-width: 0;
}
</style>
